import { QUERY_KEYS } from '@avanta/shared/constants/common';
import {
  type Enterprise,
  type UpdateEnterprisePreferencesPayload,
} from '@avanta/shared/types/enterprises';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { MUTATION_KEYS } from 'constants/common';
import { EnterprisesService } from 'services/enterprises';
import { useUserStore } from 'stores/user';

export const useUpdateEnterprisePreferences = (): UseMutationResult<
  AxiosResponse<Enterprise>,
  AxiosError,
  UpdateEnterprisePreferencesPayload
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_ENTERPRISE_PREFERENCES],
    mutationFn: async (payload: UpdateEnterprisePreferencesPayload) => {
      const enterpriseDto = useUserStore.getState().user as Enterprise;

      return EnterprisesService.updateEnterprise(enterpriseDto.id, {
        ...enterpriseDto,
        appLanguage: String(payload.appLanguage),
        timeZone: String(payload.timeZone),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_USER] });
    },
  });
};
